import linkButton from 'app/Theme/mixins/linkButton'

export default {linkButton}
